$(function () {
    $('td[data-redirect]').on('click', function () {
        let $parent = $(this).parent('tr');
        if ($parent.length) {
            let target = $parent.attr('data-href');
            if (target !== undefined) {
                window.location.href = target;
            }
        }
    })
});